import { render, staticRenderFns } from "./BackgroundWrapper.vue?vue&type=template&id=8d8b5d10&scoped=true&"
import script from "./BackgroundWrapper.vue?vue&type=script&lang=js&"
export * from "./BackgroundWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundWrapper.vue?vue&type=style&index=0&id=8d8b5d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b5d10",
  null
  
)

export default component.exports